import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import logo from '../assets/images/mkavlogo.png';

function Header() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  return (
    <header className="header_section">
      <div className="header_top">
        <div className="container-fluid">
          <div className="contact_nav">
            <a href="tel:+255717039523">
              <i className="fa fa-phone" aria-hidden="true"></i>
              <span>Call : +255 717-039523</span>
            </a>
            <a href="mailto:info@mkavanco.co.tz">
              <i className="fa fa-envelope" aria-hidden="true"></i>
              <span>Email : info@mkavanco.co.tz</span>
            </a>
            <a href="#">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              <span>Location</span>
            </a>
          </div>
        </div>
      </div>
      <div className="header_bottom">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg custom_nav-container">
            <Link className="navbar-brand" to="/">
              <img 
                src={logo} 
                width="70%" 
                height="70%" 
                alt="MK Avanco" 
                style={{ maxHeight: '60px', objectFit: 'contain' }}
              />
            </Link>

            <button 
              className="navbar-toggler" 
              type="button" 
              data-toggle="collapse" 
              data-target="#navbarSupportedContent" 
              aria-controls="navbarSupportedContent" 
              aria-expanded={!isNavCollapsed ? true : false} 
              aria-label="Toggle navigation"
              onClick={handleNavCollapse}
            >
              <span className=""></span>
            </button>

            <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarSupportedContent">
              <ul className="navbar-nav">
                <li className="nav-item active">
                  <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about-us">About</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/services">Services</Link>
                </li>
               
                <li className="nav-item">
                  <Link className="nav-link" to="/contact">Contact Us</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/login"><i className="fa fa-user" aria-hidden="true"></i> Login</Link>
                </li>
                <form className="form-inline">
                  <button className="btn my-2 my-sm-0 nav_search-btn" type="submit">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </button>
                </form>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;